/**
 * This package's translations, registered at import.
 *
 * One namespace for both audiences, because a claim is one conversation seen
 * from two sides: what the desk's screen calls "prise en charge" is the words
 * the customer reads on their own timeline, and a customer telephoning about
 * it quotes what is on their screen.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "support";

registerNamespace(NAMESPACE, { en, fr });
